import * as React from 'react';

import { Button, colors, Heading, Text, VStack } from '@rtkwlf/fenrir-react';
import { useTranslation } from 'react-i18next';

import { SadWolf } from '@packages/components/sad-wolf/sad-wolf';

/** @deprecated Please use @packages/fenrir/errors/sad-wolf-error  */
export const SadWolfError: React.FC = () => {
  const { t } = useTranslation();

  return (
    <VStack
      xAlign="center"
      yAlign="center"
      gap="large"
      style={{ height: '100vh' }}
      width="full"
    >
      <SadWolf />
      <Heading
        textAlign="center"
        style={{ color: `rgb(${colors.icon.neutral.default})` }}
      >
        {t('error:globalError.header')}
      </Heading>
      <Text textAlign="center" style={{ whiteSpace: 'pre-line' }}>
        {t('error:globalError:content')}
      </Text>
      <Button
        onClick={() => {
          window.location.reload();
        }}
      >
        {t('error:globalError.refresh')}
      </Button>
    </VStack>
  );
};
